import { $, $$ } from './dom.js';

export function initHeader() {
  const header = $('#siteHeader');
  const toggle = $('#menuToggle');
  const menu = $('#mobileMenu');
  const progress = $('#scrollProgress');
  const background = [$('#main'), $('.site-footer')].filter(Boolean);

  function updateScrollUi() {
    header?.classList.toggle('is-scrolled', window.scrollY > 30);
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (progress) progress.style.width = max > 0 ? `${Math.min(100, (window.scrollY / max) * 100)}%` : '0%';
  }

  function closeMenu() {
    toggle?.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', 'Menüyü aç');
    menu?.classList.remove('is-open');
    menu?.setAttribute('aria-hidden', 'true');
    background.forEach((element) => { element.inert = false; });
    document.body.style.overflow = '';
  }

  menu && (menu.inert = true);
  toggle?.addEventListener('click', () => {
    const opening = !menu?.classList.contains('is-open');
    toggle.classList.toggle('is-open', opening);
    toggle.setAttribute('aria-expanded', String(opening));
    toggle.setAttribute('aria-label', opening ? 'Menüyü kapat' : 'Menüyü aç');
    menu?.classList.toggle('is-open', opening);
    menu?.setAttribute('aria-hidden', String(!opening));
    if (menu) menu.inert = !opening;
    background.forEach((element) => { element.inert = opening; });
    document.body.style.overflow = opening ? 'hidden' : '';
    if (opening) menu?.querySelector('a')?.focus();
  });

  $$('#mobileMenu a').forEach((link) => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) {
      closeMenu();
      toggle?.focus();
    }
  });
  window.addEventListener('scroll', updateScrollUi, { passive: true });
  window.addEventListener('resize', updateScrollUi);
  updateScrollUi();
}
